// extracted by mini-css-extract-plugin
export var buttonContainer = "_7j-1";
export var fontSizeSelect = "_7j-3";
export var formatSelect = "_7j-2";
export var formats = "_7j-4";
export var hidden = "_7j-5";
export var icon = "_7j-6";
export var select = "_7j-0";